const PrivacyPolicy = () => (
  <div style={{ padding: "2rem" }}>
    <h1>Privacy Policy</h1>
    <p>
      Your privacy is important to us. We collect only necessary data to provide services and never share it with third parties without consent.
    </p>
  </div>
);
export default PrivacyPolicy;
